import { useCallback, useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsBand from "@/pages/home/components/StatsBand";
import GuideSection from "@/pages/home/components/GuideSection";
import TimelineSection from "@/pages/home/components/TimelineSection";
import ArchiveSection from "@/pages/home/components/ArchiveSection";
import DigestSection from "@/pages/home/components/DigestSection";
import DownloadSection from "@/pages/home/components/DownloadSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";
import ActionToast from "@/pages/home/components/ActionToast";

export default function Home() {
  const [toast, setToast] = useState("");

  const notify = useCallback((message: string) => {
    setToast(message);
  }, []);

  const closeToast = useCallback(() => {
    setToast("");
  }, []);

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50 font-sans text-foreground-900">
      <SiteHeader onAction={notify} />
      <main>
        <HeroSection onAction={notify} />
        <StatsBand />
        <GuideSection />
        <TimelineSection />
        <ArchiveSection onAction={notify} />
        <DigestSection />
        <DownloadSection onAction={notify} />
        <FaqSection />
      </main>
      <SiteFooter />
      <ActionToast message={toast} onClose={closeToast} />
    </div>
  );
}